import HubMenuService from './hub-menu-service';
import PageService from '../page-service';

const pageService = new PageService();
const hubMenuService = new HubMenuService(pageService);

export default hubMenuService;